import { GetService } from 'src/app/Services/get.service';
import { Component, Inject, Optional } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material/dialog';
import { User } from 'src/app/login/login models/user';

@Component({
  selector: 'app-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.scss'],
})
export class DeleteComponent {

  public componentUrl: string;
  constructor(private dialogRef: MatDialogRef<DeleteComponent>,
    @Inject(MAT_DIALOG_DATA) public message:string) {

    }

    onCancel(){
      this.dialogRef.close()
    }
  }
